import { createStore } from 'vuex'
import auth from './auth'

export default createStore({
  state: {
    // state properties here
  },
  getters: {
    // getters here
  },
  mutations: {
    // mutations here
  },
  actions: {
    // actions here
  },
  modules: {
    auth,
  }
})
